export enum BackgroundColors {
  White = 'white',
  Grey = '',
  'Light beige' = 'beige',
  Lavender = 'lavender'
}